var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-loading"},[_c('span',{staticClass:"list-loading__label"},[_vm._v(_vm._s(_vm.$t('loading', { resource: '...' })))]),_c('FontAwesomeIcon',{staticClass:"list-loading__spinner",attrs:{"icon":['fal', 'spinner-third'],"spin":"","size":"2x"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }